<div class="min-vh-100 bg-light">
  <app-header [page]="'Wallets'"></app-header>

  <main class="container py-4">
    <div class="d-flex justify-content-between align-items-center mb-3">
      <div>
        <h4 class="mb-0 fw-bold">Withdrawal History</h4>
        <div class="text-muted small">Track your withdrawal requests</div>
      </div>

      <div class="d-flex gap-2">
        <button *ngIf="filterWalletId" class="btn btn-outline-secondary btn-sm" type="button" (click)="backToWallet()">
          Back to Wallet
        </button>

        <button class="btn btn-outline-secondary btn-sm" type="button" (click)="loadWithdrawals()">
          Refresh
        </button>
      </div>
    </div>

    <div class="card shadow-sm border-0">
      <div class="card-body">
        <div *ngIf="loading" class="text-center py-4">
          <div class="spinner-border spinner-border-sm me-2"></div>
          Loading withdrawals...
        </div>
        <div *ngIf="filterWalletId" class="alert alert-info py-2 px-3 mb-3">
          Showing withdrawals for selected wallet
          <a class="ms-2" (click)="clearFilter()" style="cursor:pointer;">Clear</a>
        </div>

        <div class="table-responsive" *ngIf="!loading">
          <table class="table align-middle">
            <thead>
              <tr>
                <th>Withdrawal ID</th>
                <th>Date</th>
                <th>Currency</th>
                <th>Amount</th>
                <th>Status</th>
                <th>Reference</th>
                <th>Gateway Ref</th>
                <th>Failure Reason</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of withdrawals" [class.table-info]="isHighlighted(item)">
                <td>
                  <button class="btn btn-link btn-sm p-0 text-decoration-none fw-semibold" type="button"
                    (click)="openDetails(item)">
                    {{ item.withdrawalId }}
                  </button>
                </td>
                <td>{{ item.createdAt | date:'medium' }}</td>
                <td>{{ item.currency.code }}</td>
                <td>{{ item.amount | smartAmount:item.currency.symbol }}</td>
                <td>
                  <span [class]="getDepositAndWithdrawalStatusClass(item.status, true)">
                    {{ item.status }}
                  </span>
                  <div class="alert alert-danger mt-2 small" *ngIf="item.failureReason">
                    {{ item.failureReason }}
                  </div>
                </td>
                <td class="small">{{ item.externalReference }}</td>
                <td class="small">{{ item.gatewayReference || '-' }}</td>
                <td class="small text-danger">{{ item.failureReason || '-' }}</td>
                <td class="text-end">
                  <button *ngIf="canRetry(item)" class="btn btn-outline-primary btn-sm" type="button"
                    (click)="retry(item)" [disabled]="retryingId === item.withdrawalId">
                    <span *ngIf="retryingId === item.withdrawalId" class="spinner-border spinner-border-sm me-2"></span>
                    Retry
                  </button>
                </td>
              </tr>

              <tr *ngIf="!withdrawals.length">
                <td colspan="9" class="text-center text-muted py-4">
                  No withdrawals found.
                </td>
              </tr>
            </tbody>
          </table>
          <app-pagination *ngIf="meta && meta.totalRows > 0" [url]='url' [counts]='meta!'
            (refresh)="loadWithdrawals($event)"></app-pagination>
        </div>
      </div>
    </div>

    <app-footer></app-footer>
  </main>
</div>
<app-withdrawal-details-modal [(visible)]="showDetailsModal" [withdrawal]="selectedWithdrawal">
</app-withdrawal-details-modal>